<template lang="pug">
    .row.faq-entry-wrapper
        .col-12.col-sm-12
            h5(v-html="entry.title.rendered", @click="toggle()")
        .col-12.col-sm-12.content(v-html="entry.content.rendered", v-show="opened")

</template>

<script>
export default {
  name: 'FaqEntry',
  props: ['entry'],
  data() {
    return {
      opened: false,
    }
  },
  methods: {
    toggle() {
      this.opened = !this.opened
    },
  },
}
</script>

<style scoped lang="scss">
@import './../variables';

h5 {
  color: $color-black;
  margin: $gutter * 1.5 0;
  cursor: pointer;
}

.content {
  margin-bottom: $gutter;
  padding-top: $gutter;
  padding-bottom: $gutter;
  font-size: 0.95em;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/FaqEntry.vue